import { Box, useTheme } from '@mui/material';
import React from 'react';
import type { DropPosition } from './types';

export type EdgeIndicatorEdge = 'top' | 'bottom' | null;

export const positionToEdge = (
  position: DropPosition | null,
): EdgeIndicatorEdge => {
  if (position === 'above') return 'top';
  if (position === 'below') return 'bottom';
  return null;
};

interface EdgeDropIndicatorProps {
  edge: EdgeIndicatorEdge;
}

export const EdgeDropIndicator: React.FC<EdgeDropIndicatorProps> = ({
  edge,
}) => {
  const theme = useTheme();
  const palette = theme.customColorPalette;
  if (!edge) return null;
  return (
    <Box
      sx={{
        height: '3px',
        backgroundColor: palette.blue[500],
        margin: '0 8px',
        borderRadius: '1.5px',
        pointerEvents: 'none',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '-2px',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '7px',
          height: '7px',
          borderRadius: '50%',
          backgroundColor: palette.blue[500],
        }}
      />
    </Box>
  );
};
